import { CRM_WEB_PAGES_URLS } from '../../CRM_WEB_PAGES_URLS';
import { OrganizationSettings } from '@care-portals/api-interfaces';

export const demo_clinic: OrganizationSettings = {
  name: 'Demo',
  replyToEmail: 'doctor@secure-message.appgen.health',
  ecommerceEnabled: false,
  stripeEnabled: false,
  conversationServiceId: 'IS9d8b15500b914f3a98bff0a083e18592',
  emrEnabled: true,
  patientPortalDomain: 'demo_clinic.portals.care',
  appointmentconsentSection: `
      <p style="text-align: center;color: #536476;">
        By booking you agree to our&nbsp;
        <a
          href="javascript:window.open('https://policies.google.com/privacy?hl=en-US', 'popup', 'width=600,height=600');"
        >
            Clinic Policies
        </a>
      </p>
    `,

  // navigation
  crmWebAppLayout: {
    title: 'Demo Clinic',
    logo: 'https://uploads-ssl.webflow.com/5f8415ff3a31a8a99ee9197f/6024e65c3d57838a05d302a1_appgen-logomark-dark.png',
    mainMenu: [
      {
        title: 'Patients',
        link: CRM_WEB_PAGES_URLS.leads.list,
        icon: 'fa-regular fa-address-book',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: CRM_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fa-regular fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: CRM_WEB_PAGES_URLS.tasks.list,
        icon: 'fa-solid fa-list-check',
        roles: ['*']
      },
      {
        title: 'Segments',
        link: CRM_WEB_PAGES_URLS.segment.list,
        icon: 'fa-solid fa-table-columns',
        roles: ['*']
      },
      {
        title: 'Admin',
        link: '',
        icon: 'fas fa-user-cog',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Services',
            link: CRM_WEB_PAGES_URLS.services.list,
            icon: 'fas fa-medkit',
            roles: ['*']
          },
          {
            title: 'Schedules',
            link: CRM_WEB_PAGES_URLS.schedules.list,
            icon: 'fas fa-calendar',
            roles: ['admin']
          },
          {
            title: 'Users',
            link: CRM_WEB_PAGES_URLS.users.list,
            icon: 'fas fa-lock',
            roles: ['admin']
          },
          {
            title: 'Layouts',
            link: CRM_WEB_PAGES_URLS.layouts.list,
            icon: 'fas fa-columns',
            roles: ['admin', 'developer']
          },
          {
            title: 'Recurring Tasks',
            link: CRM_WEB_PAGES_URLS.recurringTasks.list,
            icon: 'fas fa-recycle',
            roles: ['admin', 'developer']
          },
          // {
          //   title: 'Schemas',
          //   link: CRM_WEB_PAGES_URLS.crmSchemas.list,
          //   icon: 'fas fa-receipt',
          //   roles: ['admin', 'developer']
          // },
          {
            title: 'Forms',
            link: CRM_WEB_PAGES_URLS.forms.list,
            icon: 'fas fa-table',
            roles: ['admin', 'developer']
          },
          {
            title: 'Workflows',
            link: CRM_WEB_PAGES_URLS.workflows.list,
            icon: 'fas fa-code-branch',
            roles: ['admin', 'developer']
          },
          {
            title: 'Templates',
            link: CRM_WEB_PAGES_URLS.emailTemplates.list,
            icon: 'fas fa-palette',
            roles: ['admin', 'developer']
          },
          {
            title: 'Settings',
            link: CRM_WEB_PAGES_URLS.settings.base,
            icon: 'fa-solid fa-sliders',
            roles: ['admin', 'developer', 'owner']
          }
        ]
      }
    ]
  }
};
